import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";

/**
 * The payline element is used for hold payline special cases and handle payline behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Payline extends SwitchElement {
    //special payline cases
    static CaseNormal: string = "NORMAL";
    static CaseShow: string = "SHOW";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseFirstWin: string = "FIRST_WIN";
    static CaseSingleWin: string = "SINGLE_WIN";
    static CaseSelect: string = "SELECT";

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {
        super.create(node);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Payline.ts
 **/